import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterActive',
})
export class FilterActivePipe implements PipeTransform {
  transform<T>(values: T[], ...args: any[]): any {
    if (!values) {
      return;
    }

    if (!args[0]) {
      return values;
    }
    const active = args[0] === 'true';
    if (active) {
      return values.filter((item) => item[args[1]]);
    }
    return values.filter((item) => !item[args[1]]);
  }
}
